<template>
  <div>
    <v-layout class="justify-center align-center" style="height: 100%;width: 100%;position: absolute;">
      <v-progress-circular
          :size="64"
          indeterminate
          color="primary">
      </v-progress-circular>
    </v-layout> 
  </div>
</template>

<script>
  

  export default {
    page: {
      title: "....",
    },
    components: { },
    data() {
      return { }
    },
  }
</script>

